// Geocoding helpers using Open-Meteo (free, no API key).
const GEO_URL = "https://geocoding-api.open-meteo.com/v1/search";

export async function searchCity(query) {
  if (!query || query.trim().length < 2) return [];
  const url = `${GEO_URL}?name=${encodeURIComponent(query.trim())}&count=8&language=en&format=json`;
  try {
    const res = await fetch(url);
    if (!res.ok) return [];
    const data = await res.json();
    return (data.results || []).map((r) => ({
      id: `${r.id}`,
      name: r.name,
      country: r.country,
      admin1: r.admin1,
      lat: r.latitude,
      lng: r.longitude,
      timezone: r.timezone,
      displayName: [r.name, r.admin1, r.country].filter(Boolean).join(", "),
    }));
  } catch {
    return [];
  }
}

export async function reverseGeocode(lat, lng) {
  // Open-Meteo doesn't have reverse; we just return a synthetic name
  return {
    name: `Lat ${lat.toFixed(2)}, Lng ${lng.toFixed(2)}`,
    lat,
    lng,
    country: "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    displayName: `My Location`,
  };
}
